export const denormalize = (value: number, min: number, max: number) => {
  return value * (max - min) + min
}
export const normalize = (value: number, min: number, max: number) => {
  return (value - min) / (max - min)
}
